import { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import UseFetch from "../components/UseFetch";
import EditeDetteMax from "../Clients/EditeDetteMax";
import ModalEditeCLient from "../Clients/ModalEditeClient";
import $ from "jquery";
import "datatables.net-bs5"; // assure-toi que DataTables est bien installé avec Bootstrap 5

const AllClients = () => {
    const { data: clients, isloading } = UseFetch("clients");
    const [selectedClient, setSelectedClient] = useState(null);
    const tableRef = useRef(null);

    useEffect(() => {
        if (clients && clients.length > 0 && tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [clients]);

    if (isloading) return <div className="loader"></div>;

    return (
        <div className="client container-fluid">
            <div className="row align-items-center justify-content-between my-3">
                <div className="col text-primary h3">🧾 Liste Générale des Clients</div>
            </div>

            <div className="table-responsive">
                <table
                    ref={tableRef}
                    className="table table-bordered table-hover table-striped  nowrap"
                >
                    <thead className="table-primary">
                        <tr className="text-center align-middle ">
                            <th>#</th>
                            <th>Client</th>
                            <th>Téléphone</th>
                            <th>Adresse</th>
                            <th>Solde Total</th>
                            <th>Crédit Total</th>
                            <th>Dette Max</th>
                            <th>Agent</th>
                            <th className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients?.map((client, index) => (
                            <tr key={index} className="align-middle">
                                <td>{index + 1}</td>
                                <td className="critere">{client.client}</td>
                                <td>{client.telephone}</td>
                                <td>{client.adresse}</td>
                                <td>{client.solde?.toLocaleString()} GNF</td>
                                <td>{client.creditTotal?.toLocaleString()} GNF</td>
                                <td>{client.dettemax?.toLocaleString()} GNF</td>
                                <td>{client.agent}</td>
                                <td className="text-end">
                                    <button
                                        className="btn btn-sm btn-primary me-1"
                                        onClick={() => setSelectedClient(client)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#modalEditeClient"
                                        title="Modifier client"
                                    >
                                        <i className="bx bx-edit"></i>
                                    </button>
                                    <NavLink
                                        to="/client/compte"
                                        state={{ client }}
                                        className="btn btn-sm btn-info"
                                        title="Voir le compte"
                                    >
                                        <i className="bx bx-show"></i>
                                    </NavLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modals */}
            <EditeDetteMax client={selectedClient} />
            <ModalEditeCLient client={selectedClient} />
        </div>
    );
};

export default AllClients;
